import { WifiOff } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { useConnectivity } from "./connectivity";
import { OfflineSaleScreen } from "./OfflineSaleScreen";

/**
 * A screen that needs the server (返品, 買取, 委託受付, お会計 with card …) while the register is
 * offline: says so in one sentence and what can be done instead — never an error after tapping.
 */
export function RequireOnline({ children, titleKey }: { children: ReactNode; titleKey: string }) {
  const { t } = useTranslation();
  const connectivity = useConnectivity();
  if (connectivity.state === "online") {
    return <>{children}</>;
  }
  return (
    <section className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center">
      <WifiOff aria-hidden className="size-14 text-pos-problem" />
      <h1 className="text-3xl font-semibold">{t(titleKey)}</h1>
      <p className="max-w-xl text-xl">{t("offline.screen_online_only")}</p>
      <Link
        to="/"
        className="flex min-h-pos-touch items-center rounded-md bg-primary px-8 text-xl font-semibold text-primary-foreground"
      >
        {t("offline.back_to_sale")}
      </Link>
    </section>
  );
}

/** 販売: the server's basket online, the offline basket (cash only) without the server. */
export function SaleOrOffline({ children }: { children: ReactNode }) {
  const connectivity = useConnectivity();
  return connectivity.state === "online" ? <>{children}</> : <OfflineSaleScreen />;
}
